import { PredefinedPricingTierValue } from './predefined-pricing-tier.value';
import { PredefinedPricingTierValueDto } from './predefined-pricing-tier.value.dto';

export class PredefinedPricingTiersValueDto {
    tiers: PredefinedPricingTierValueDto[];

    constructor(values: PredefinedPricingTierValue[]) {
        this.tiers = values.map((value) => new PredefinedPricingTierValueDto(value));
    }
}
